import Vue from 'vue';
import { mapGetters } from 'vuex';
import _ from 'lodash';
import { cssGenerator } from '@/mixins/css-generator';
import tooltip from '@/mixins/components/tooltip';
import { SQUASH_DROPLET } from '@/constants';
import DropletOptions from '../_bubble-options';
import menuGridOptions from './components/_edit-options';
import schema from './droplet.schema';
const dropletSchema = schema();

export default Vue.component('menu-grid', {
  template: require('./template.html'),
  name: 'menu-grid',
  mixins: [cssGenerator],
  computed: {
    ...mapGetters([
      'currentSite',
      'currentPage',
      'viewport',
      'localStyle',
      'activeDroplet',
      'activeState',
      'animationPreview',
      'dropletObserver',
      'dragging',
      'globalBubbleOptionsOpen',
      'globalOpenModal',
    ]),
    roamingTemplate() {
      return this.currentPage.type !== 'template' && this.droplet.templateRegion;
    },
    isActiveDroplet() {
      return this.activeDroplet._id === this.droplet._id;
    },
    hideTransform() {
      return this.dragging || this.globalBubbleOptionsOpen;
    },
    feed() {
      const enabled = this.currentSite.dynamic && this.currentSite.dynamic.restaurant;
      const feed = enabled ? _.cloneDeep(enabled.published || []) : [];
      _.forEach(feed, (item) => {
        item.image = this._servePrefix(item.image) + item.image;
      });
      return feed;
    },
    profile() {
      return this._dropletType(this.droplet);
    },
    displayStatus() {
      let settings = {
        desktop: 'default',
        tablet: 'default',
        mobile: 'default',
      };
      const selector = _.find(this.droplet.mediaQueries, { selector: ', .drzMenu-grid' });
      if (selector) {
        const property = _.find(selector.properties, { property: 'display' });
        if (property) {
          settings = property;
        }
      }
      return settings;
    },
  },
  data() {
    return {
      type: dropletSchema.type,
      SQUASH_DROPLET,
      display: {
        top: null,
        left: null,
        right: null,
        bottom: null,
        ctPaddingTop: null,
        ctPaddingBottom: null,
        ctPaddingLeft: null,
        ctPaddingRight: null,
        transform: null,
        perspective: null,
        searchLetterSpacing: null,
        searchBrdrWidthLeft: null,
        searchBrdrWidthRight: null,
        searchBrdrWidthTop: null,
        searchBrdrWidthBottom: null,
        searchBrdrRadiusTopLeft: null,
        searchBrdrRadiusTopRight: null,
        searchBrdrRadiusBottomLeft: null,
        searchBrdrRadiusBottomRight: null,
        barRadiusTopRight: null,
        barRadiusTopLeft: null,
        barRadiusBottomRight: null,
        barRadiusBottomLeft: null,
        fbPaddingTop: null,
        fbPaddingBottom: null,
        fbPaddingLeft: null,
        fbPaddingRight: null,
        'box-shadow': null,
        'letter-spacing': null,
        'border-top-width': null,
        'border-bottom-width': null,
        'border-left-width': null,
        'border-right-width': null,
        'border-top-right-radius': null,
        'border-top-left-radius': null,
        'border-bottom-right-radius': null,
        'border-bottom-left-radius': null,
      },
      hidden: false,
      dropletHovered: false,
      setBubbleSize: 'dropletBubble-normal',
      showEditBubble: false,
      showRevealClass: false,
    };
  },
  props: ['droplet', 'items', 'index'],
  components: {
    DropletOptions,
    menuGridOptions,
    tooltip,
  },
  watch: {
    isActiveDroplet(is) {
      if (is) {
        this._scrollToDroplet(this.$el);
      }
    },
    'activeDroplet._id': function c(id) {
      if (!id) {
        this.showRevealClass = false;
      }
    },
    activeState(state) {
      if (state === ':reveal' && this.isActiveDroplet) {
        this.showRevealClass = true;
      } else {
        this.showRevealClass = false;
      }
    },
    animationPreview(should) {
      if (should && this.isActiveDroplet) {
        const droplet = this.$refs.dropletRow;
        const $droplet = $(droplet);
        $droplet.drzOnReveal({
          editing: this.isActiveDroplet,
          child: '.drzMenu-grid',
        });
      }
    },
    viewport() {
      this.callCssGenerator();
      this.observeVisibility();
    },
    'localStyle.value': function setLocals() {
      this.setDisplay();
    },
    dropletObserver(id) {
      if (this.droplet._id === id) {
        this.observeVisibility();
        this.$store.dispatch('setDropletObserver', false);
      }
    },
    globalOpenModal(open) {
      if (!open) {
        // we trigger the rerender here if user is adding new dynamic data
        this.destroyPlugin();
        this.initPlugin();
      }
    },
  },
  mounted() {
    this.callCssGenerator();
    this.observeVisibility();
    this.initPlugin();
  },
  methods: {
    callCssGenerator() {
      return this.generateCSS({
        drp: this.droplet,
      });
    },
    observeVisibility() {
      const display = this.displayStatus;
      if (display[this.viewport] === 'none' || (display[this.viewport] === 'default' && display.desktop === 'none')) {
        this.hidden = true;
      } else {
        this.hidden = false;
      }
    },
    setDisplay() {
      if (this.activeDroplet._id === this.droplet._id) {
        const styles = this.localStyle;
        if (styles.properties.length > 0) {
          _.forEach(styles.properties, (property) => {
            this.$set(this.display, property, styles.value);
          });
        } else {
          _.forOwn(this.display, (value, key) => {
            this.display[key] = null;
          });
        }
      }
    },
    toggleBubble() {
      if (!this.roamingTemplate) {
        this.showEditBubble = !this.showEditBubble;
      }
    },
    destroyPlugin() {
      const $droplet = $(this.$refs.menuGrid);
      $droplet.drzFilterGrid.destroy($droplet);
    },
    initPlugin() {
      const $droplet = $(this.$refs.menuGrid);
      const enabled = this.currentSite.dynamic && this.currentSite.dynamic.restaurant;
      const categories = enabled ? enabled.categories : [];
      const customCategories = this.droplet.customCategories;
      let filters = false;
      if (!this.droplet.hideFilters && !this.droplet.customList && categories.length > 0) {
        filters = categories;
      }
      if (!this.droplet.hideFilters && this.droplet.customList && customCategories.length > 0) {
        filters = customCategories;
      }
      let feed = this.feed;
      if (this.droplet.customList) {
        feed = feed.filter(p => customCategories.some(f => p.categories.indexOf(f) >= 0));
      }
      const _id = this.droplet._id;
      $droplet.drzFilterGrid({
        output(data) {
          const calories = data.calories ? `<span class="drzMenu-grid-calories">${data.calories} calories</span>` : '';
          const link = data.modal ? '#' : data.pageLink;
          const innerStart = data.modal || data.pageLink ? `<a class="drzMenu-grid-inner" href="${link}">` : '<div class="drzMenu-grid-inner">';
          const innerEnd = data.modal || data.pageLink ? '</a>' : '</div>';
          const price = data.price ? `<span class="drzMenu-grid-price">${data.price}</span>` : '';
          const categories = data.categories.length > 0 ? `<div class="drzMenu-grid-categories">${data.categories.join(', ')}</div>` : '';
          const modal = `<div class="drzModal-overlay" data-droplet-id="drp-${_id}">
            <div class="drzModal-closeRow"><a class="drzModal-closeLink" href="#"></a></div>
            <div class="drzModal-content drzModal-medium">
              <div class="row">
                <div class="column col-4">
                  <img class="drzMenu-grid-img" src="${data.image}" alt="${data.name}" />
                </div>
                <div class="column col-8">
                  <div class="drzMenu-grid-info" style="width:100%;">
                    <h4 class="drzMenu-grid-name">${data.name}</h4>
                    ${price}
                    ${calories}
                    ${categories}
                    <div class="drzMenu-grid-footer">
                      <p class="drzMenu-grid-desc">${data.description}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>`;
          const needsModal = data.modal ? modal : '';
          return `
          <div class="drzMenu-grid-card">
            ${innerStart}
              <div class="drzMenu-grid-cardImageWrap">
                <img class="drzMenu-grid-cardImage" data-asset="${data.image}" alt="${data.name}" />
              </div>
              <div class="drzMenu-grid-cardInfo">
                <div class="drzMenu-grid-infoColLeft">
                  <span class="drzMenu-grid-name">${data.name}</span>
                  ${calories}
                </div>
                <div class="drzMenu-grid-infoColRight">
                  ${data.categories.join(', ')}
                </div>
              </div>
            ${innerEnd}
            ${needsModal}
          </div>
          `;
        },
        onRender($card) {
          const $modal = $card.find('.drzModal-overlay');
          const $link = $card.find('.drzMenu-grid-inner');
          if ($modal.length) {
            $link.drzModal();
          } else {
            $link.click(e => e.preventDefault());
          }
        },
        filters,
        pagination: this.droplet.paginate,
        sortKey: this.droplet.sortKey,
        sort: this.droplet.sort,
        filterText: this.droplet.filterText,
        searchKeys: ['name', 'description'],
        feed,
      });
    },
  },
});



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/menu-grid/index.js